import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { map, Observable } from 'rxjs';

import { BaseService } from './base.service';
import { CancelGatewayTransactionResponse, Ticket } from '../models';
import { ErrorService } from 'src/app/services/error/error.service';
import { ApiType } from 'src/app/pos.config';
import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends BaseService {
  constructor(
    private http: HttpClient,
    store: Store,
    private readonly errorService: ErrorService,
    private readonly translocoService: TranslocoService
  ) {
    super(store);
  }

  //Endpoint used to delete a Gateway Stripe Transaction Only - does NOT support Datacap
  cancelGatewayTransaction(
    ticketUuid: string,
    gatewayTransactionId: number
  ): Observable<CancelGatewayTransactionResponse> {
    return this.http.delete<CancelGatewayTransactionResponse>(
      this.getLocationUrl(
        `tickets/${ticketUuid}/payment_gateway_transactions/${gatewayTransactionId}`
      )
    );
  }

  payOnPickup(deviceTicketUuid: string) {
    return this.http
      .post<{ success: boolean; ticket: Ticket }>(
        this.getLocationUrl(`tickets/${deviceTicketUuid}/pay_on_pickup`),
        {}
      )
      .pipe(map((response) => response.ticket));
  }

  finalizeMealPlanTicket(
    deviceTicketUuid: string
  ): Observable<{ success: boolean; ticket: Ticket }> {
    return this.http
      .post<{ success: boolean; ticket: Ticket }>(
        this.getLocationUrl(
          `tickets/${deviceTicketUuid}/finalize_mealplan_order`
        ),
        {},
        {
          params: {
            loadingText: this.translocoService.translate(
              'messages.closingTicket'
            )
          }
        }
      )
      .pipe(this.errorService.retryPipe(ApiType.Mutate));
  }
}
